import React from 'react';
import classes from './Sample.module.css';
import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import CustomTextField from '../../../components/UI/Inputs/CustomTextField';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { format, parseISO } from 'date-fns';
import { fetchCustomers, ICustomer, selectCustomers } from '../../../store/slices/customers';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { editSampleTaken } from '../../../store/slices/samplesTaken';

import { barCodeValidation } from '../../../utils/miscUtils';
import { useTranslation } from '../../../hooks/useTranslations';

const Sample: React.FC<{ selectedSalesOrder: SalesOrderInfo }> = ({ selectedSalesOrder }) => {
  const dispatch = useAppDispatch();
  const customers: ICustomer[] = useAppSelector<ICustomer[]>(selectCustomers);
  const [editSampleBarcode, setEditSampleBarcode] = React.useState<string>('');
  const { translations } = useTranslation();
  const isPcr = selectedSalesOrder?.product?.product_name.includes('PCR');
  const isAntigenAntibody =
    selectedSalesOrder?.product?.product_name.toLowerCase().includes('antigen') ||
    selectedSalesOrder?.product?.product_name.toLowerCase().includes('antibody') ||
    selectedSalesOrder?.product?.product_name.toLowerCase().includes('antikörpertest');

  React.useEffect(() => {
    if (
      selectedSalesOrder?.diagnostic_results &&
      selectedSalesOrder?.diagnostic_results[0]?.sample_barcode
    ) {
      setEditSampleBarcode(selectedSalesOrder?.diagnostic_results[0]?.sample_barcode);
    }
    dispatch(fetchCustomers());
  }, [dispatch, selectedSalesOrder]);

  const customer: ICustomer | undefined = React.useMemo(() => {
    return customers.find(
      (customer) => customer.person_id == selectedSalesOrder?.customer_person?.person_id
    );
  }, [selectedSalesOrder.customer_person?.person_id, customers]);

  return (
    <div className={classes.container}>
      <div className={classes.fieldsContainer}>
        <div className={classes.fields}>
          <CustomTextField
            label={translations('patient.last_name').toString()}
            value={customer?.person_lastname ?? ''}
            onChange={() => {}}
            disabled
            maxWidth="300px"
          />
        </div>
        <div className={classes.fields}>
          <CustomTextField
            label={translations('patient.first_name').toString()}
            value={customer?.person_firstname ?? ''}
            onChange={() => {}}
            disabled
            maxWidth="300px"
          />
        </div>
        <div className={classes.fields}>
          <CustomTextField
            label={translations('diagnostic.type').toString()}
            value={selectedSalesOrder?.service?.service_name ?? ''}
            onChange={() => {}}
            disabled
            maxWidth="300px"
          />
        </div>
        <div className={classes.fields}>
          <CustomTextField
            label={translations('sample.taken.date').toString()}
            value={format(
              parseISO(
                selectedSalesOrder?.work_order_service_diagnostic?.check_in_time?.toString() ??
                  '01-01-1111'
              ),
              'dd.MM.yyyy HH:mm'
            )}
            onChange={() => {}}
            disabled
            maxWidth="300px"
          />
        </div>
        <div className={classes.fields}>
          <CustomTextField
            label={translations('sample.id').toString()}
            value={editSampleBarcode}
            onChange={(e: any) => setEditSampleBarcode(e.target.value)}
            maxWidth="300px"
          />
        </div>
        <div className={classes.fields}>
          <CustomTextField
            label={translations('sample.taken.by').toString()}
            value={
              selectedSalesOrder?.diagnostic_results
                ? `${selectedSalesOrder?.diagnostic_results[0].person_firstname ?? ''} ${
                    selectedSalesOrder?.diagnostic_results[0].person_lastname ?? ''
                  }`
                : ''
            }
            onChange={() => {}}
            disabled
            maxWidth="300px"
          />
        </div>
      </div>
      <PrimaryButtonV2
        text={translations('save')}
        containerStyle={{
          width: '100%',
          justifyContent: 'start',
          marginTop: 'auto',
        }}
        buttonStyle={{
          padding: '10px',
          height: 50,
          width: 300,
        }}
        disabled={barCodeValidation(
          editSampleBarcode,
          selectedSalesOrder?.employeePerson?.person_id,
          isPcr,
          isAntigenAntibody
        )}
        onClick={() => {
          dispatch(
            editSampleTaken({
              sampleBarcode: editSampleBarcode,
              sampleTakenId: selectedSalesOrder?.diagnostic_results
                ? selectedSalesOrder?.diagnostic_results[0].sample_taken_id ?? 0
                : 0,
            })
          );
        }}
      />
    </div>
  );
};

export { Sample };
